<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- <ion-title>Additional Information</ion-title> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading" v-if="routeName!='additional_onboard_locum_job_seeker'">
                    <h1>Additional Information</h1>
                    <!-- <p class="auth-subtext">Sign in with email and password!</p> -->
                </div>
                <div class="auth-heading" v-else>
                    <h1>Build Your Job Seeker Profile</h1>
                    <p class="auth-subtext">Tell Us What You’re Looking For</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :model="form" ref="userForm" label-position="top">
                <el-form-item :error="v$.salary_expectation_hourly.$error" :show-message="false" class="no-scroll"
                    :required="true" prop="salary_expectation_hourly">
                    <div class="inner-label">
                        <!-- <div class="label-main" v-if="routeName!='additional_onboard_locum_job_seeker'">
                            
                            Minimum Hourly Rate
                            <span class="sub-label" v-if="isAustralia">(Excluding super)</span>
                        </div> -->
                        <div class="label-main">
                            <!-- Hourly Payment Range -->
                            Your Ideal Hourly Rate
                            <span class="sub-label" v-if="isAustralia">(Excluding super)</span>
                        </div>
                    </div>
                    <div class="input-wrapper">
                        <el-input data-testid="directions-124" v-model="form.salary_expectation_hourly"
                            placeholder="0.00" @input="validateField('salary_expectation_hourly')">
                            <template #suffix>{{ $filters.getSystemCurrency() }}</template>
                        </el-input>
                    </div>
                    <el-form-item-error v-if="v$.salary_expectation_hourly.$error">{{
                        v$.salary_expectation_hourly.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item :error="v$.salary_expectation_annually.$error" :show-message="false" class="no-scroll"
                    :required="true" prop="salary_expectation_annually">
                    <div class="inner-label">
                        <!-- <div class="label-main" v-if="routeName!='additional_onboard_locum_job_seeker'">
                            Minimum Annual Salary
                            <span class="sub-label" v-if="isAustralia">(Excluding super)</span>
                        </div> -->
                        <div class="label-main">
                            <!-- Annual Payment Range -->
                            You Ideal Annual Salary
                            <span class="sub-label" v-if="isAustralia">(Excluding super)</span>
                        </div>
                    </div>
                    <div class="input-wrapper">
                        <el-input data-testid="directions-125" v-model="form.salary_expectation_annually"
                            placeholder="0.00" @input="validateField('salary_expectation_annually')">
                            <template #suffix>{{ $filters.getSystemCurrency() }}</template>
                        </el-input>
                    </div>
                    <el-form-item-error v-if="v$.salary_expectation_annually.$error">{{
                        v$.salary_expectation_annually.$errors[0].$message }}</el-form-item-error>
                </el-form-item>
                <!-- <el-form-item :error="v$.profile_type_id.$error" :show-message="false" class="no-scroll"
                    :required="true" :label="Level" prop="profile_type_id">
                    <div class="item-select__header">
                        <div class="item-select__title">Level</div>
                    </div>
                    <el-radio-group data-testid="directions-116" v-model="form.profile_type_id"
                        @change="validateField('level')">
                        <el-radio v-for="level in getJobSeekerLevel" :key="level.id" :label="level.id">{{ level.title
                            }}</el-radio>
                    </el-radio-group>
                    <el-form-item-error v-if="v$.profile_type_id.$error">{{ v$.profile_type_id.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item> -->

                <el-form-item :error="v$.federal_pharmacist_support?.$error" :show-message="false"
                    class="no-scroll is-federal" :required="true" label="Are you a federal pharmacist?" v-if="isUS">
                    <el-radio-group v-model="form.federal_pharmacist_support">
                        <el-radio :label=1 size="large">Yes</el-radio>
                        <el-radio :label=0 size="large">No</el-radio>
                    </el-radio-group>
                    <el-form-item-error v-if="v$.federal_pharmacist_support?.$error">{{ v$.federal_pharmacist_support?.$errors[0]?.$message
                    }}</el-form-item-error>
                </el-form-item>
                <el-form-item :error="v$.year_experience_id.$error" :show-message="false" class="no-scroll"
                    :required="true" prop="level">
                    <div class="item-select__header" v-if="routeName!='additional_onboard_locum_job_seeker'">
                        <div class="item-select__title">Experience</div>
                    </div>
                    <div class="item-select__header" v-else>
                        <div class="item-select__title">How Many Years Have You Worked?</div>
                    </div>
                    <el-radio-group data-testid="directions-114" v-model="form.year_experience_id"
                        @change="validateField('year_experience_id')">
                        <el-radio v-for="level in getExperiences" :key="level.id" :label="level.id">{{
                            level.yearExperience
                            }}</el-radio>
                    </el-radio-group>
                    <el-form-item-error v-if="v$.year_experience_id.$error">{{ v$.year_experience_id.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item :error="v$.category_level_ids.$error" :show-message="false"
                    class="no-scroll job-role-preferences" :required="true" prop="category_level_ids">
                    <div class="item-select__header" v-if="routeName!='additional_onboard_locum_job_seeker'">
                        <div class="item-select__title">Role</div>
                    </div>
                    <div class="item-select__header" v-else>
                        <div class="item-select__title">Job Role Preferences </div>
                    </div>
                    <el-checkbox-group data-testid="directions-104" v-model="form.category_level_ids"
                        @change="handleCheckboxRoleChange">
                        <el-checkbox v-for="level in getSeekerCategories" :key="level.id" :label="level.id">{{
                            level.title
                            }}</el-checkbox>

                    </el-checkbox-group>
                    <el-form-item-error v-if="v$.category_level_ids.$error">{{ v$.category_level_ids.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <div v-if="showOtherInput">
                    <el-input v-model="form.category_level_other" placeholder="Please specify other role"
                        @input="validateField('category_level_other')" @blur="validateField('category_level_other')" />
                    <el-form-item-error v-if="v$.category_level_other.$error">{{
                        v$.category_level_other.$errors[0].$message
                        }}</el-form-item-error>
                </div>
                <el-form-item :show-message="false" class="no-scroll job-skills" :required="true" prop="job_skills"
                    v-if="routeName != 'additional_onboard_locum_job_seeker'">
                    <div class="item-select__header">
                        <div class="item-select__title">Skills</div>
                    </div>
                    <el-checkbox-group data-testid="directions-104" v-model="form.job_skills">
                        <el-checkbox v-for="skill in skillLists" :key="skill.value" :label="skill.value">{{ skill.label
                            }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit btn-primary" type="primary" data-testid="directions-126"
                        :disabled="isSubmitDisabled" @click="handleSubmit">
                        <span v-if="routeName == 'additional_onboard_locum_job_seeker'">Continue</span>
                        <span v-else>Save</span>
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, computed, inject, onMounted, ref, onBeforeMount, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

import {
    useRouter,
    useRoute
} from "vue-router";

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    directives: {},
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const routeName = $route.name;
        const setPageClassGlobal = inject("setPageClassGlobal");
        const user = $store.getters.GET_USER_DATA;
        let getJobSeekerLevel = ref([]);
        let getExperiences = ref([]);
        let getSeekerCategories = ref([]);
        let skillLists = ref([]);
        const isAustralia = isAustraliaRegion();
        const isUS = isUSRegion();

        const backPage = $store.getters.getLastPage;

        const settings = ref (user.role === 'job-seeker' ? user.settings : user.locumAsJobSeekerSetting);
        // console.log("🚀 ~ setup ~ settings:", settings)
        const form = reactive({
            salary_expectation_hourly: settings.value?.salaryExpectationHourly ? settings.value?.salaryExpectationHourly : '',
            salary_expectation_annually: settings.value?.salaryExpectationAnnually ? settings.value?.salaryExpectationAnnually : '',
            ...(isUS.value && { federal_pharmacist_support: user.federalPharmacistSupport ? user.federalPharmacistSupport : 0 }),
            // profile_type_id: settings.value?.profileTypeId ? settings.value?.profileTypeId : '',
            category_level_other: settings.value?.categoryLevelOther ? settings.value?.categoryLevelOther : '',
            year_experience_id: settings.value?.yearExperienceId ? settings.value?.yearExperienceId : '',
            category_level_ids: settings.value?.categoryLevelIds ? settings.value?.categoryLevelIds : [],
            job_skills: user.skills ? user.skills.map(skill => skill.id) : [],
        });

        const pageText = {
            pageTitle: 'Your profile',
            formText: 'what are your salary expectations?',
        };

        const rules = computed(() => {
            return {
                salary_expectation_hourly: {
                    required: helpers.withMessage('Please enter valid ideal hourly rate', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Validator to ensure max 3 digits before the decimal, allowing an optional trailing decimal
                    maxThreeDigitsBeforeDecimal: helpers.withMessage(
                        'Only up to 3 digits are allowed before the decimal',
                        (value) => /^\d{1,3}(\.\d*)?$/.test(value)
                    ),
                    // New validator to ensure there’s a digit after the decimal if a decimal is present
                    // decimalRequiresFraction: helpers.withMessage(
                    //     'If using a decimal, please enter at least one digit after the decimal',
                    //     (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
                    // ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                },
                salary_expectation_annually: {
                    required: helpers.withMessage('Please enter valid ideal annual salary', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Validator to ensure max 7 digits before the decimal, allowing an optional trailing decimal
                    maxThreeDigitsBeforeDecimal: helpers.withMessage(
                        'Only up to 7 digits are allowed before the decimal',
                        (value) => /^\d{1,7}(\.\d*)?$/.test(value)
                    ),
                    // New validator to ensure there’s a digit after the decimal if a decimal is present
                    // decimalRequiresFraction: helpers.withMessage(
                    //     'If using a decimal, please enter at least one digit after the decimal',
                    //     (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
                    // ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                },
                // profile_type_id: { required: helpers.withMessage('Please select level option', required) },
                category_level_other: {
                    requiredIf: requiredIf(() => form.category_level_ids.includes(otherCategoryId.value)),
                    // Add custom message for the requiredIf validation
                    required: helpers.withMessage(
                        'Please enter the category level for "Other"',
                        requiredIf(() => form.category_level_ids.includes(otherCategoryId.value))
                    ),
                },
                year_experience_id: { required: helpers.withMessage('Please select the experience', required) },
                category_level_ids: { required: helpers.withMessage('Please enter the role', required) },
            };
        });

        const v$ = useVuelidate(rules, form);

        const isSubmitDisabled = computed(() => {
            // Check if "Other" is selected
            const isOtherSelected = form.category_level_ids.includes(otherCategoryId.value);

            return Object.values(form).some((value) => {
                // Ignore category_level_other if "Other" is not selected
                if (!isOtherSelected && value === form.category_level_other) {
                    return false; // Ignore this check for category_level_other
                }
                return value === ''; // Check for other empty values
            }) || v$.value.$pending || v$.value.$error || v$.value.$invalid;
        });

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        //const checkValue = (fieldName, event) => {
        // const value = event.target.value;
        // const regex = /^\d{0,8}(\.\d{0,2})?$/;
        // if (!regex.test(value)) {
        //     // If the entered value doesn't match the format, remove the last character
        //     form[fieldName] = value.slice(0, -1);
        // } else {
        //     // Update the field's value with the validated value
        //     form[fieldName] = value;
        // }
        //};

        const handleSubmit = async () => {
            const result = await v$.value.$validate();
            console.log("🚀 ~ handleSubmit ~ result:", form)
            if (!result) {
                v$.$touch();
            } (async () => {
                try {
                    if(routeName == 'additional_onboard_locum_job_seeker'){
                        await $store.dispatch("LOCUM_UPDATE_JOB_SEEKER_SETTING", form);
                    }else{

                        await $store.dispatch("UPDATE_JOB_SEEKER_SETTING", form);
                    }
                    
                    goNext();
                } catch (error) {
                    console.log("error submit!!");
                }
            })();
        };

        const goBack = () => {
            if(routeName == 'additional_onboard_locum_job_seeker'){
                $router.push({
                        name: "welcome_locum_jobseeker",
                    });
            }else{
            if (backPage === '/job-seeker/index') {
                if(user.locumOnboardedAsJobseeker==0){
                    $router.push({
                        name: "search",
                    });
                }else{
                    $router.push({
                        name: "job_seeker_index",
                    });
                }
               
                } else if (backPage === '/job-seeker/profile/edit') {
                    $router.push({
                        name: "basic_profile_job_seeker",
                    });
                }else if (backPage === '/profile/edit') {
                    $router.push({
                        name: "profile_edit",
                    });
                }  else {
                    $router.push({
                        name: "basic_profile_job_seeker",
                    });
                }
            }

        };

        const goNext = () => {
            if(routeName == 'additional_onboard_locum_job_seeker'){
                // $router.push({
                //         name: "locum_jobseeker_cv",
                //     });
                $router.push({
                        name: "locum_jobseeker_software_experience",
                    });
            }else{
                if (backPage === '/job-seeker/index') {
                    $router.push({
                        name: "job_seeker_index",
                    });
                } else if (backPage === '/job-seeker/profile/edit') {
                    $router.push({
                        name: "basic_profile_job_seeker",
                    });
                }else if (backPage === '/profile/edit') {
                    $router.push({
                        name: "profile_edit",
                    });
                } else {
                    $router.push({
                        name: "profile_job_seeker_setting",
                    });
                }
            }
            

        };

        onMounted(() => {
            setPageClassGlobal("global_job_seeker_additional_edit_page");
        });

        onBeforeMount(async () => {
            return new Promise((resolve) => {
                // $store
                //     .dispatch("GET_JOB_SEEKER_LEVEL")
                //     .then((response) => {
                //         let FetchResult = response.data.profileTypes;
                //         console.log("🚀 ~ .then ~ FetchResult:", FetchResult)
                //         getJobSeekerLevel.value = FetchResult;
                //         console.log("🚀 ~ .then ~ jobFetchResult:", getJobSeekerLevel)
                //         resolve(response);
                //     });
                $store
                    .dispatch("GET_JOB_SEEKER_EXPERIENCE")
                    .then((response) => {
                        let FetchResult = response.data.experiences;
                        getExperiences.value = FetchResult;
                        resolve(response);
                    });
                $store
                    .dispatch("GET_JOB_SEEKER_CATEGORY")
                    .then((response) => {
                        let FetchResult = response.data.categories;
                        getSeekerCategories.value = FetchResult;
                        console.log("🚀 ~ onBeforeMount ~ FetchResultdddd", FetchResult)
                        resolve(response);
                    });
                $store.dispatch("GET_JOB_POSTER_LISTINGS").then((response) => {
                    console.log("🚀 ~ fetchSkills ~ response:", response)
                    // Assuming response.data contains the options you want to display
                    skillLists.value = response.data.popularSkills
                        .map(skill => ({ label: skill.name, value: skill.id }));
                    console.log("🚀 ~ $store.dispatch ~ skillLists:", skillLists)
                });
                $store.dispatch("GET_SKILLS").then((response) => {
                    //merge the selected skills of the user even if the skill in not verified
                    skillLists.value = skillLists.value.concat(user.skills?.map(skill => ({ label: skill.name, value: skill.id })));

                    skillLists.value = skillLists.value.concat(response.data.map(skill => ({ label: skill.name, value: skill.id })));
                    skillLists.value = skillLists.value.filter((skill, index, self) =>
                        index === self.findIndex((t) => (
                            t?.value === skill?.value
                        ))
                    );
                });
            });
        });

        // Find the ID of the "Other" option dynamically
        const otherCategoryId = computed(() => {
            const otherOption = getSeekerCategories.value.find(
                (option) => option.title === "Other"
            );
            return otherOption ? otherOption.id : null;
        });

        const showOtherInput = computed(() =>
            form.category_level_ids.includes(otherCategoryId.value)
        );

        watch(
            () => form.category_level_ids,
            (newVal) => {
                if (newVal.includes(otherCategoryId.value)) {
                    validateField('category_level_other');
                }
            }
        );

        const handleCheckboxRoleChange = (value) => {
            // Check if 'Other' was unselected
            if (!value.includes(otherCategoryId.value)) {
                form.category_level_other = null; // Reset the category_level_other field

            }
        };

        return {
            user,
            // environment,
            goBack,
            handleSubmit,
            // checkValue,
            validateField,
            isSubmitDisabled,
            pageText,
            form,
            rules,
            v$,
            getJobSeekerLevel,
            getExperiences,
            getSeekerCategories,
            skillLists,
            backPage,
            isAustralia,
            showOtherInput,
            handleCheckboxRoleChange,
            settings,
            routeName,
            isUS
        };
    },
};
</script>
<style scoped>
.button-wrapper {
    display: flex;
    margin-bottom: 10px;
}

.button-wrapper .el-button {
    margin-right: 10px;
}

.input-wrapper {
    display: flex;
    align-items: center;
}

.input-wrapper .el-input__prefix {
    margin-right: 5px;
}
</style>